"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var JourneyListContext = react_1.createContext({
    journeyList: [],
    updateJourneyList: function () { return null; },
    currentJourney: null,
    steps: [],
});
exports.default = JourneyListContext;
